import { Select } from "antd";
import { DefaultOptionType } from "antd/lib/select";
import UserTag from "components/user-tag/user-tag";
import { AcceptanceStatus } from "constants/index";
import { useProjectParticipants } from "hooks/project-participants";
import { useState, useEffect } from "react";

const { Option } = Select;

function GCReviewersDropdown(props: {
  value?: any;
  notFoundContent?: any;
  onChange?:
    | ((value: any, option?: DefaultOptionType | DefaultOptionType[]) => void)
    | undefined;
  disabled?: boolean;
  className?: string;
  defaultOpen?: boolean;
  placeholder?: string;
}) {
  const {
    value,
    notFoundContent,
    onChange,
    disabled = false,
    className = "w-full",
    defaultOpen = false,
    placeholder
  } = props;
  const { projectParticipants } = useProjectParticipants();
  const dataLoaded = projectParticipants?.dataLoaded;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (defaultOpen && dataLoaded) {
      setOpen(true);
    }
  }, [defaultOpen, dataLoaded]);
  const gcReviewers = projectParticipants?.gcReviewers?.filter((user: any) => {
    const userId = value;
    if (userId && userId === user.id) {
      return true;
    }
    return user.status_id !== AcceptanceStatus.DEACTIVATED;
  });

  return (
    <Select
      className={className}
      placeholder={placeholder}
      loading={!dataLoaded}
      value={gcReviewers?.length > 0 ? value || undefined : undefined}
      onChange={onChange}
      showSearch
      filterOption
      optionFilterProp="label"
      notFoundContent={notFoundContent}
      disabled={disabled}
      allowClear
      // antd v6 renders the Option's children as the *selected* value, so the
      // company sub-line ended up inside the closed Select (v5 clipped it to a
      // single line). Point the selected value at a name-only node; the
      // dropdown list still renders the children, sub-line included.
      optionLabelProp="selectedLabel"
      {...(defaultOpen && { open, onOpenChange: setOpen })}
    >
      {(gcReviewers ?? []).map((user: any) => {
        if (
          // The `&&` of two comparisons always yields a boolean, never nullish,
          // so the `?? ""` right operand is unreachable.
          /* v8 ignore next 3 */
          (user.status_id === AcceptanceStatus.DEACTIVATED &&
            user.id !== value?.toString()) ??
          ""
        )
          return "";

        const selectedAndInactive =
          // The `&&` of two comparisons always yields a boolean, never nullish,
          // so the `?? ""` right operand is unreachable.
          /* v8 ignore next 3 */
          (user.status_id === AcceptanceStatus.DEACTIVATED &&
            user.id === value?.toString()) ??
          "";

        const inactiveTag = user.status_id === AcceptanceStatus.DEACTIVATED && (
          <div className="absolute flex w-full items-center justify-end pr-3 -mt-[1px]">
            <UserTag label="Inactive" />
          </div>
        );

        return (
          <Option
            key={user.id}
            value={user.id}
            label={`${user.first_name} ${user.last_name} ${user?.company?.name}`}
            selectedLabel={
              <>
                {inactiveTag}
                {user.first_name} {user.last_name}
              </>
            }
            className={selectedAndInactive ? "hidden" : ""}
            firstName={user.first_name}
            lastName={user.last_name}
            company={user?.company}
          >
            {inactiveTag}
            <div>
              {user.first_name} {user.last_name}
            </div>
            <div className="text-sm text-gray-500">{user?.company?.name}</div>
          </Option>
        );
      })}
    </Select>
  );
}

export default GCReviewersDropdown;
